import { Button } from '~/components/buttons/Button/Button';
import { LoadingSpinner } from '~/components/LoadingSpinner';

/**
 * A visible shell for the short period before Clerk settles the session or a
 * satellite hand-off reaches the primary host. Without this, Clerk's signed-in
 * and signed-out gates both render nothing, which leaves only App's base-grey
 * background on screen.
 */
export const AuthLoading = ({
  message = 'Loading secure authentication…',
}: {
  message?: string;
}) => (
  <div className="flex min-h-screen items-center justify-center bg-primary-t-950 px-6">
    <div className="flex flex-col items-center gap-4 text-center">
      <LoadingSpinner size={20} bgColor="bg-primary-t-950" />
      <p aria-live="polite" className="body-text text-grey-400">
        {message}
      </p>
    </div>
  </div>
);

/**
 * Clerk exposes a terminal failed state when its script cannot be loaded. A
 * reload is the only safe recovery here: there is no authenticated client to
 * retry from, and it preserves the current path for the user.
 */
export const AuthUnavailable = () => (
  <div className="flex min-h-screen items-center justify-center bg-primary-t-950 px-6 py-12">
    <div className="flex max-w-md flex-col items-center gap-4 text-center">
      <h1 className="heading-large text-grey-100">We couldn&apos;t load secure authentication</h1>
      <p className="body-text text-grey-400">
        Check your connection and try again. If the problem continues, please reload the page.
      </p>
      <Button label="Try again" type="button" onClick={() => window.location.reload()} />
    </div>
  </div>
);
